import type {
  AppearanceComponentContent,
  Banner,
  TvChannel,
  TvShow,
  Vod,
} from '@setplex/tria-api'
import type {
  AdjustPurchaseableFn,
  AdjustPurchaseableFnFactory,
} from '~/features/payment/sse-purchases'

import { MediaTypes as MediaTypesEnum } from '@setplex/tria-api'
// --- old formatters helpers, TODO: refactor this
import {
  extendMediaItemByLabelPrice,
  extendMediaItemByLabelPriceTvChannel,
} from '~/shared/tools'
// ---

// Prepare items for view/ui components
export function adjustBannersBundle(
  content: { bannerBundles?: Banner<Vod | TvShow | TvChannel>[] },
  adjustFactory: AdjustPurchaseableFnFactory | undefined
) {
  if (!adjustFactory) throw new Error('Missing adjustFactory.')

  let adjust: AdjustPurchaseableFn

  const bannerBundles = content?.bannerBundles

  if (
    bannerBundles == null ||
    !Array.isArray(bannerBundles) ||
    bannerBundles.length === 0
  )
    return

  const formattedBannerBundles: Banner<Vod | TvShow | TvChannel>[] = []
  for (const bannerBundle of bannerBundles) {
    let formattedBanner

    if (bannerBundle.content) {
      switch (bannerBundle.contentType) {
        case MediaTypesEnum.VOD: {
          adjust = adjustFactory('vod', 'vodSet')
          formattedBanner = extendMediaItemByLabelPrice(
            adjust<Vod>(bannerBundle.content as Vod)
          )
          break
        }
        case MediaTypesEnum.TV_CHANNEL: {
          adjust = adjustFactory('channel', 'channelSet')
          formattedBanner = extendMediaItemByLabelPriceTvChannel(
            adjust<TvChannel>(bannerBundle.content as TvChannel)
          )
          break
        }
        case MediaTypesEnum.TV_SHOW: {
          adjust = adjustFactory('tvShow', 'tvShowSet')
          formattedBanner = extendMediaItemByLabelPrice(
            adjust<TvShow>(bannerBundle.content as TvShow)
          )
          break
        }
        default: {
          formattedBanner = bannerBundle.content
        }
      }
    }

    formattedBannerBundles.push({
      ...bannerBundle,
      content: formattedBanner,
    })
  }

  content.bannerBundles = formattedBannerBundles

  return content
}

export const filterBannersByIdentifier = (
  identifier: string,
  componentContent: AppearanceComponentContent
): AppearanceComponentContent => {
  let filtered = componentContent?.content?.bannerBundles

  if (!filtered) return componentContent

  switch (identifier) {
    case 'tv_channels': {
      filtered = filtered.filter(
        ({ contentType }) =>
          contentType === MediaTypesEnum.TV_CHANNEL ||
          contentType === MediaTypesEnum.TV_CATEGORY
      )
      break
    }
    case 'movie': {
      filtered = filtered.filter(
        ({ contentType }) =>
          contentType === MediaTypesEnum.VOD ||
          contentType === MediaTypesEnum.VOD_CATEGORY ||
          contentType === MediaTypesEnum.VOD_SUBCATEGORY
      )
      break
    }
    case 'tv_shows': {
      filtered = filtered.filter(
        ({ contentType }) =>
          contentType === MediaTypesEnum.TV_SHOW ||
          contentType === MediaTypesEnum.TV_SHOW_CATEGORY ||
          contentType === MediaTypesEnum.TV_SHOW_SUBCATEGORY
      )
      break
    }
  }

  componentContent.content.bannerBundles = filtered

  return componentContent
}
